var config = {
  bucketName: "setugrambucket",
  region: "ap-south-1",
  accessKeyId: "AKIAYW3GYDJSBZOOUXXF",
  secretAccessKey: "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",
  s3Url: "https://setugrambucket.s3.ap-south-1.amazonaws.com",
};

export const Config = config;
